import React, { useEffect } from 'react'
import Form from '../../components/Form'
import InputText from '../../components/Inputs/InputText'
import FormItem from '../../components/Form/FormItem'
import { useForm } from 'react-hook-form'
import InputNumber from '../../components/Inputs/InputNumber'
import Datepicker from '../../components/Inputs/Datepicker'
import Button from '../../components/General/Button'
import Select from '../../components/Inputs/Select'
import InputRadio from '../../components/Inputs/InputRadio'
import { formatPipe } from '../../utils/utils'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Card,
  Collapse,
  Typography,
} from '@mui/material'
import { AiOutlineArrowDown } from 'react-icons/ai'
import { IoIosArrowDown } from 'react-icons/io'
import CurrencyInput from '../../components/Inputs/CurrencyInput'
import Bancrecer from '../../assets/images/bancrecer.svg'
import LogoBNC from '../../assets/images/bnc-original.svg'
import { docs } from '../../userConfig'

const CardForm: React.FC<ICardForm> = ({ onSubmit, amount, isLoading, disabledInput }) => {
  const form = useForm({
    defaultValues: {
      amount: amount,
      accountType: 'ahorro',
    },
  })

  const cardTypeOptions = [
    {
      value: 'visa',
      text: 'Visa',
    },
    {
      value: 'mastercard',
      text: 'Mastercard',
    },
    {
      value: 'debit',
      text: 'Débito Maestro',
    },
  ]

  const monthOptions = [
    { value: '01', text: '01' },
    { value: '02', text: '02' },
    { value: '03', text: '03' },
    { value: '04', text: '04' },
    { value: '05', text: '05' },
    { value: '06', text: '06' },
    { value: '07', text: '07' },
    { value: '08', text: '08' },
    { value: '09', text: '09' },
    { value: '10', text: '10' },
    { value: '11', text: '11' },
    { value: '12', text: '12' },
  ]

  const yearOptions = Array.from({ length: 20 }, (_, i) => {
    const year = new Date().getFullYear() + i
    return { value: year.toString(), text: year.toString() }
  })

  return (
    <>
      <Form
        form={form}
        classes={`gap-x-2 gap-y-2`}
        onSubmit={(values) => {
          onSubmit({
            ...values,
            amount: values?.amount || `Bs. ${formatPipe(amount + '')}`,
          })
        }}
      >
        <div
          className="col-span-12"
          style={{ color: '#102b6d', fontWeight: 500 }}
        >
          Tarjeta
        </div>

        {/* Tipo de cuenta - Radio buttons */}
        <div className="col-span-12">
          <FormItem
            name="accountType"
            rules={{ required: 'Es necesario seleccionar el tipo de cuenta' }}
            defaultValue="ahorro"
          >
            <InputRadio
              label="Tipo de cuenta"
              options={[
                { name: 'Ahorro', value: 'ahorro', selected: true },
                { name: 'Corriente', value: 'corriente', selected: false },
              ]}
            />
          </FormItem>
        </div>

        {/* Columna izquierda */}
        <div className="col-span-6">
          {/* Número de tarjeta */}
          <FormItem
            name="cardNumber"
            rules={{ required: 'Es necesario el número de tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Nro de tarjeta"
              innerProps={{
                type: 'text',
                placeholder: '1234 5678 9012 3456',
                maxLength: 19,
              }}
            />
          </FormItem>

          {/* Titular de la tarjeta */}
          <FormItem
            name="cardHolder"
            rules={{ required: 'Es necesario el titular de la tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Titular de la tarjeta"
              innerProps={{
                type: 'text',
                placeholder: 'Nombre completo',
              }}
            />
          </FormItem>

          {/* Monto */}
          <FormItem
            name="amount"
            defaultValue={amount || ''}
            rules={{
              required: 'Es necesario el monto',
            }}
          >
            <CurrencyInput
              disabled={disabledInput}
              addDecimals={true}
              mask="Bs. num"
              label="Monto"
            />
          </FormItem>

          <div className="col-span-12 flex flex-row">
            <FormItem
              name="documentType"
              rules={{ required: 'Es necesario un nombre' }}
              classes="w-[30%]"
              defaultValue={docs[0]}
            >
              <Select options={docs} label="Tipo" />{' '}
            </FormItem>

            {/* Documento */}
            <FormItem
              name="document"
              rules={{ required: 'Es necesario el documento' }}
              defaultValue=""
            >
              <InputText
                maxLength={9}
                label="Documento"
                innerProps={{
                  type: 'text',
                  placeholder: '12345678',
                }}
              />
            </FormItem>
          </div>
        </div>

        {/* Columna derecha */}
        <div className="col-span-6">
          {/* CVC */}
          <FormItem
            name="cvc"
            rules={{ required: 'Es necesario el CVC' }}
            defaultValue=""
          >
            <InputText
              label="CVC"
              innerProps={{
                type: 'text',
                placeholder: '123',
                maxLength: 4,
              }}
            />
          </FormItem>

          {/* PIN de la tarjeta */}
          <FormItem
            name="cardPin"
            rules={{ required: 'Es necesario el PIN de la tarjeta' }}
            defaultValue=""
          >
            <InputText
              label="Pin de la tarjeta"
              innerProps={{
                type: 'password',
                placeholder: '••••',
              }}
            />
          </FormItem>

          {/* Mes y año */}
          <div className="flex gap-2">
            <FormItem
              name="expiryMonth"
              classes="flex-1"
              rules={{ required: 'Es necesario el mes' }}
              defaultValue={monthOptions[0]}
            >
              <Select label="Mes" options={monthOptions} />
            </FormItem>
            <FormItem
              name="expiryYear"
              classes="flex-1"
              rules={{ required: 'Es necesario el año' }}
              defaultValue={yearOptions[0]}
            >
              <Select label="Año" options={yearOptions} />
            </FormItem>
          </div>

          {/* Tipo de tarjeta */}
          <FormItem
            name="cardType"
            rules={{ required: 'Es necesario el tipo de tarjeta' }}
            defaultValue={cardTypeOptions[0]}
          >
            <Select label="Tipo de tarjeta" options={cardTypeOptions} />
          </FormItem>
        </div>

        <div className="col-span-12 h-full flex flex-row">
          <div className="w-full pr-1 mt-3">
            <Button
              type="primary"
              classes="w-full"
              htmlType="submit"
              disabled={isLoading}
              loading={isLoading}
            >
              Continuar
            </Button>
          </div>
        </div>

        {/* <div
        style={{ height: 1, width: '100%', backgroundColor: '#CFCFCF' }}
        className="col-span-12 mt-3"
      ></div>

<div className='col-span-12 mt-3 flex flex-col items-center'>
          <label className='text-center text-sm' style={{color: '#7C7C7C'}}>Operación realizada a través de la plataforma de BNC</label>
          <div className='mt-3'>
          <img src={LogoBNC} height={70} width={70}/>
          </div>
      </div> */}
      </Form>
    </>
  )
}

export default CardForm

interface ICardForm {
  onSubmit: (values: any) => void
  isLoading: boolean
  amount: number
  disabledInput: boolean
}
